export const JIRA_CART_ITEM_ID = 'jira-cart-item';
